import type { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import CustomRatesModal from './CustomRatesModal';
import { PROVIDERS_REQUIRING_USER_ID } from './constants';
import useCompanyCustomRates from './useCompanyCustomRates';

const CompanyCustomRates: FunctionComponent = function () {
  const { onShowModal, allRates, existing, hasExisting, isLoading } =
    useCompanyCustomRates();
  return (
    <>
      <Button.Text
        id="staff-company-custom-rates"
        label="Edit custom rates"
        onClick={onShowModal}
        variant="solid"
      />
      <CustomRatesModal
        allRates={allRates}
        existing={existing}
        hasExisting={hasExisting}
        providersRequiringUserId={PROVIDERS_REQUIRING_USER_ID}
        isLoading={isLoading}
      />
    </>
  );
};

export default CompanyCustomRates;
